import React from 'react';
import { EmptyState } from '../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { RealizedGainLossDetailsSkeleton } from './RealizedGainLossDetailsSkeleton';

interface Props {
  title: string;
}

export const RealizedGainLossDetailsEmpty = ({ title }: Props) => {
  return (
    <RealizedGainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </RealizedGainLossDetailsSkeleton>
  );
};
